import React from 'react';
import { Col, Typography } from 'antd';
import { ActiveIcon, EarningsIcon, LikeIcon, LogInIcon, SignUpIcon, UserPaymentIcon } from '../Icon';
import moment from 'moment';

const { Text } = Typography;

const Client = ({usersDetailsData}: any) => (
  <>
    <h3 className="user-activity-title">Payment</h3>
    <div className="user-activity">
      <Col span={24} style={{ display: 'flex' }}>
        <EarningsIcon />
        <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '12px' }}>
          <Text className="text">Total paid</Text>
          <Text>{`₪ ${usersDetailsData?.payments?.total}`}</Text>
        </div>
      </Col>
      <Col span={24} style={{ display: 'flex' }}>
        <EarningsIcon />
        <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '12px' }}>
          <Text className="text">Subs. paid</Text>
          <Text>{`₪ ${usersDetailsData?.payments?.subscriptions}`}</Text>
        </div>
      </Col>
      <Col span={24} style={{ display: 'flex' }}>
        <EarningsIcon />
        <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '12px' }}>
          <Text className="text">Tips. Amount</Text>
          <Text>{`₪ ${usersDetailsData?.payments?.tips_amount}`}</Text>
        </div>
      </Col>
    </div>
    <h3 className="user-activity-title">Payment date</h3>
    <div className="user-activity">
      <Col span={24} style={{ display: 'flex' }}>
        <UserPaymentIcon />
        <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '12px' }}>
          <Text className="text">First payment</Text>
          <Text>{moment(usersDetailsData?.payments?.first).format('ddd MMMM Do YYYY')}</Text>
        </div>
      </Col>
      <Col span={24} style={{ display: 'flex' }}>
        <UserPaymentIcon />
        <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '12px' }}>
          <Text className="text">Last payment</Text>
          <Text>{moment(usersDetailsData?.payments?.last).format('ddd MMMM Do YYYY')}</Text>
        </div>
      </Col>
    </div>
    <h3 className="user-activity-title">Activity</h3>
    <div className="user-activity">
      <Col span={24} style={{ display: 'flex' }}>
        <ActiveIcon />
        <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '12px' }}>
          <Text className="text">Active subscriptions</Text>
          <Text>{usersDetailsData?.active_subscriptions}</Text>
        </div>
      </Col>
      <Col span={24} style={{ display: 'flex' }}>
        <LikeIcon />
        <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '12px' }}>
          <Text className="text">Liked</Text>
          <Text>{usersDetailsData?.likes_count}</Text>
        </div>
      </Col>
      <Col span={24} style={{ display: 'flex' }}>
        <LikeIcon />
        <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '12px' }}>
          <Text className="text">Total subs plans</Text>
          <Text>{usersDetailsData?.payments?.subscriptions_paid_count}</Text>
        </div>
      </Col>
      <Col span={24} style={{ display: 'flex' }}>
        <LikeIcon />
        <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '12px' }}>
          <Text className="text">Tipped</Text>
          <Text>{usersDetailsData?.payments?.tips_count}</Text>
        </div>
      </Col>
    </div>
    <h3 className="user-activity-title">Log in information</h3>
    <div className="user-info">
      <Col span={12} style={{ display: 'flex' }}>
        <SignUpIcon />
        <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '12px' }}>
          <Text className="text">Sign up</Text>
          <Text>{moment(usersDetailsData?.created_at).format('ddd MMMM Do YYYY, h:mm:ss')}</Text>
        </div>
      </Col>
      <Col span={12} style={{ display: 'flex' }}>
        <LogInIcon />
        <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '12px' }}>
          <Text className="text">Last log in</Text>
          <Text>{moment(usersDetailsData?.last_active).format('ddd MMMM Do YYYY, h:mm:ss')}</Text>
        </div>
      </Col>
    </div>
  </>
);

export default Client;